// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ki-3";
export var downloadButton = "_ki-4";
export var fileContainer = "_ki-9 _ki-7";
export var fileContainerBase = "_ki-7";
export var fileContainerBaseSm = "_ki-a _ki-7";
export var fileContainerFixedHeight = "_ki-8 _ki-7";
export var fileContainerFixedHeightSm = "_ki-c _ki-a _ki-7";
export var fileContainerSm = "_ki-b _ki-a _ki-7";
export var fileInfo = "_ki-5";
export var fileInfoWidthRestricted = "_ki-6";
export var fileType = "_ki-1";
export var fileTypeName = "_ki-2";
export var fileTypeSm = "_ki-d _ki-1";
export var image = "_ki-0";
export var link = "_ki-f";
export var overflowEllipsis = "_ki-e";